import { iconClassName, logoClassName } from './styles';

const Logo = () => {
  return (
    <div className={logoClassName}>
      <i className={iconClassName}>
        <svg
          viewBox="0 0 625 625"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <title>cardjoy</title>
          <g id="Group" stroke="#1E3050">
            <rect
              id="Square"
              strokeWidth="58"
              fill="#EAF7FF"
              x="29"
              y="29"
              width="567"
              height="567"
              rx="132"
            ></rect>
            <g
              id="Heart"
              transform="translate(149.000000, 173.000000)"
              fill="#FFFFFF"
              fillRule="nonzero"
              strokeWidth="50"
            >
              <g id="Shape">
                <path
                  d="M30.4565625,165.147647 L146.076328,273.029562 C150.875156,277.50599 157.209609,280 163.8,280 C170.390391,280 176.724844,277.50599 181.523672,273.029562 L297.143437,165.147647 C316.594687,147.050088 327.6,121.662346 327.6,95.1235228 L327.6,91.4144825 C327.6,46.7141513 295.287891,8.60056415 251.202656,1.24643241 C222.025781,-3.61368944 192.337031,5.91470734 171.478125,26.7620721 L163.8,34.4359487 L156.121875,26.7620721 C135.262969,5.91470734 105.574219,-3.61368944 76.3973437,1.24643241 C32.3121094,8.60056415 0,46.7141513 0,91.4144825 L0,95.1235228 C0,121.662346 11.0053125,147.050088 30.4565625,165.147647 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </i>
    </div>
  );
};

Logo.displayName = 'Logo';

export default Logo;
